export class LicenseAuditLogsRequest {
    LicenseID: number;
    StartDate: Date;
    EndDate: Date;
}
